import { render, staticRenderFns } from "./LogoUnion.vue?vue&type=template&id=3a8096aa&scoped=true&"
import script from "./LogoUnion.vue?vue&type=script&lang=ts&"
export * from "./LogoUnion.vue?vue&type=script&lang=ts&"
import style0 from "./LogoUnion.vue?vue&type=style&index=0&id=3a8096aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8096aa",
  null
  
)

export default component.exports